import type { ReactNode } from "react";
import PageTitle from "./PageTitle";

export default function PageHeader({
  title,
  subtitle,
  actions,
  className = "",
  rawTitle = false,
}: {
  title: ReactNode;
  subtitle?: ReactNode;
  actions?: ReactNode;
  className?: string;
  rawTitle?: boolean;
}) {
  return (
    <header className={`mb-8 flex flex-wrap items-start justify-between gap-4 ${className}`.trim()}>
      <div>
        {rawTitle ? title : <PageTitle>{title}</PageTitle>}
        {subtitle && (
          <p className="text-gray-400 text-sm" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
            {subtitle}
          </p>
        )}
      </div>
      {actions && <div className="flex items-center gap-2 shrink-0">{actions}</div>}
    </header>
  );
}
